import { React, useState, useContext, useEffect } from 'react';
import { AccountContext } from '../Accounts'
import { useHistory, useLocation } from 'react-router-dom'
import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text,
  NavBtnLink
} from './SigninElements';


const SignIn = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(true);
  const [message, setMessage] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const { authenticate, getSession, logout } = useContext(AccountContext);

  useEffect(() => {
    getSession()
      .then(session => {
        setStatus(true);
      })
      .catch(err => {
        const params = new URLSearchParams(location.search);
        const shouldDemo = params.get("ds") === "true";

        if (shouldDemo) {
          setUsername("demouser");
          setPassword(process.env.REACT_APP_DEMOP)
        }
        console.log(err);
      })
  });

  const onSubmit = event => {
    event.preventDefault();

    authenticate(username, password)
      .then(data => {
        history.push(`/account${location.search}`);
      })
      .catch(err => {
        setSubmitStatus(false);
        if (err.toString().includes('disabled')) {
          setMessage("Your account is still under review, please try again later or contact us directly");
        }
        console.error('Failed to login!', err);
      })
  };

  return (
    <>
      <Container>
        <FormWrap>
          {status ? (
            <FormContent>
              <Form action="#">
                <FormH1>Are you sure you want to sign out?</FormH1>
                <FormButton type='submit' checked={true} onClick={logout}>Sign Out</FormButton>
              </Form>
            </FormContent>
          ) :
            <FormContent>
              <Form action='#'>
                <FormH1>Sign in to your account</FormH1>
                <FormLabel htmlFor='for'>Username</FormLabel>
                <FormInput value={username} onChange={event => setUsername(event.target.value)} required />
                <FormLabel htmlFor='for'>Password</FormLabel>
                <FormInput type='password' value={password} onChange={event => setPassword(event.target.value)} required />
                {submitStatus ? (
                  <FormButton type='submit' checked={password} onClick={onSubmit}>Sign In</FormButton>
                ) :
                  <FormButton type='submit' checked={password} onClick={onSubmit}>Log in issue, please try again</FormButton>
                }
                <Text>{message}</Text>
                <NavBtnLink to='/reset'>Password Reset</NavBtnLink>
                <Text></Text>
                <NavBtnLink to='/signup'>Sign Up</NavBtnLink>
              </Form>
            </FormContent>
          }
        </FormWrap>
      </Container>
    </>
  );
};

export default SignIn;
